<div *ngIf="translationsLoaded">
  <mat-progress-bar mode="indeterminate" color="accent" class="auth-mb-md" *ngIf="isLoading">
  </mat-progress-bar>

  <!-- TO-DO: Translate rules strings coming from BE -->
  <ul *ngIf="rules" class="auth-text-secondary auth-text-left auth-list-unstyled">
    <li *ngFor="let rule of rules">{{ rule }}</li>
  </ul>
  
  <ul class="auth-text-secondary auth-text-left auth-list-unstyled" *ngIf="rules === ['']">
    <li>Must not be similar to user email or name.</li>
    <li>Must be at least 6 characters long.</li>
    <li>Must not be a common password.</li>
    <li>Must not be entirely numeric.</li>
  </ul>

  <form name="createPassword" [formGroup]="form" (submit)="createPassword()" novalidate>
    <sn-form [form]="form" [(model)]="formModel" [fields]="formFields" [options]=""></sn-form>

    <div class="auth-text-right">
      <sn-flat-button [disabled]="form.invalid" type="submit" color="success" [isLoading]="isLoading"
        >{{ 'common.next' | t }}</sn-flat-button
      >
    </div>
  </form>
</div>
